import { useDispatch, useSelector } from 'react-redux';
import { getClinicDetail as getClinicDetailAction } from 'Redux/modules/clinics/actions';
import { useCallback, useEffect } from 'react';

const useClinicDetail = (clinicId: number) => {
  const dispatch = useDispatch();

  const {
    clinicDetail,
    status: { clinicDetail: loadingClinicDetail },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } = useSelector(state => state.clinics);

  const getClinicDetail = useCallback(() => {
    if (!clinicId) return;

    dispatch(getClinicDetailAction(clinicId));
  }, [clinicId, dispatch]);

  useEffect(() => {
    getClinicDetail();
  }, [getClinicDetail]);

  return {
    clinicDetail,
    getClinicDetail,
  };
};

export default useClinicDetail;
